import { render, staticRenderFns } from "./Bimviewer.vue?vue&type=template&id=a9c9d79e&"
import script from "./Bimviewer.vue?vue&type=script&lang=js&"
export * from "./Bimviewer.vue?vue&type=script&lang=js&"
import style0 from "./Bimviewer.vue?vue&type=style&index=0&id=a9c9d79e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports